import { render, staticRenderFns } from "./DeliveryTypeForm.vue?vue&type=template&id=a9a97c04&scoped=true"
import script from "./DeliveryTypeForm.vue?vue&type=script&lang=js"
export * from "./DeliveryTypeForm.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTypeForm.vue?vue&type=style&index=0&id=a9a97c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a97c04",
  null
  
)

export default component.exports